@if (isLoading) {
  <po-loading-overlay
    p-text="Carregando"
    p-size="sm"
  ></po-loading-overlay>
}

<po-page-default>
  <div class="po-row">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
      <p class="po-font-title">Contagem Finalização OP</p>
    </div>
  </div>

  <div
    class="po-row po-flex po-mt-2 po-mb-2"
    style="justify-content: flex-start"
  >
    <po-button
      p-kind="primary"
      p-icon="an an-plus"
      (p-click)="openModal()"
      p-label="Nova Contagem"
      class="po-mt-1 po-xl-2 po-lg-4 po-md-12 po-sm-12 po-text-center"
    ></po-button>
  </div>

  <po-table
    [p-columns]="columns"
    [p-items]="items"
    p-actions-right
  >
    <ng-template
      p-table-cell-template
      let-row="row"
      let-column="column"
    >
      @if (column.property === 'action') {
        <span
          class="po-button-group"
          [style.visibility]="row.status === 11 ? 'hidden' : 'visible'"
        >
          <po-button
            p-size="small"
            p-kind="secondary"
            p-icon="po-icon-delete"
            p-danger="true"
            class="po-ml-2"
            (p-click)="confirmDeleteCount(row.branchCode, row.code)"
          ></po-button>

          <po-button
            p-size="small"
            p-kind="secondary"
            p-icon="po-icon-arrow-right"
            (p-click)="goToCountDetails(row.branchCode, row.code, row.description)"
          ></po-button>
        </span>
      }
    </ng-template>
  </po-table>
</po-page-default>

<po-modal
  #countModal
  p-title="Nova Contagem"
  [p-primary-action]="{
    label: 'Continuar',
    action: saveCount.bind(this),
    disabled: countForm.invalid,
  }"
  [p-secondary-action]="{ label: 'Voltar', action: closeModal.bind(this) }"
>
  <form
    [formGroup]="countForm"
    class="po-p-3"
  >
    <div class="po-row">
      <po-radio-group
        class="po-md-5 po-sm-5"
        formControlName="isSingleReading"
        p-label="Leitura de OP única?"
        [p-options]="singleReadingOptions"
      ></po-radio-group>
    </div>

    <div class="po-row">
      <po-input
        class="po-md-12"
        formControlName="countDescription"
        p-label="Descrição"
        p-placeholder="Descrição opcional"
      ></po-input>
    </div>

    <div class="po-row">
      <po-input
        class="po-md-6"
        formControlName="cycleCode"
        p-label="Ciclo"
        p-placeholder="Informe o ciclo"
        [p-required]="countForm.get('isSingleReading')?.value"
        #cycleInput
      ></po-input>

      <po-input
        class="po-md-6"
        formControlName="orderCode"
        p-label="OP (Ordem de Produção)"
        p-placeholder="Informe a OP"
        [p-required]="countForm.get('isSingleReading')?.value"
        #orderInput
      ></po-input>
    </div>
  </form>
</po-modal>

<app-toaster></app-toaster>
